import React, { useState } from 'react'
import Container from '../components/Container'
import InterviewTab from '../components/interview/InterviewTab'
import TimeSelect from '../components/interview/TimeSelect'
import TutorSelect from '../components/interview/TutorSelect'

const Interview = () => {
  const [timeSelected, setTimeSelected] = useState(false)
  const handleTimeSelected = () => {
    setTimeSelected(!timeSelected)
  }
  return (
    <Container>
        <InterviewTab />
        {timeSelected ? 
        <TutorSelect 
          handleTimeSelected = {handleTimeSelected}
        />
         :
        <TimeSelect 
          handleTimeSelected = {handleTimeSelected}
        />
      }
    </Container>
  )
}

export default Interview